module.exports = __webpack_public_path__ + "media/public/img/landing_page/hiw3-rp-4b5d3de716d9ea8c3f45ef83758d0733.jpg";